import './Water.css';

const NavBarFooter = () => {
    return (
        <nav>
           <h1>MADE WITH🫀</h1>
        </nav>
    )
}

export default NavBarFooter;